// home.component.ts - Enhanced version
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
    private domUpdateTimeout: any;

    contentTitle = 'Revolutionary IT Solutions – XipeTech';
    contentDescription = 'Welcome to XipeTech, We provide the most responsive and functional IT Services. Invest your money in Developing a Brand, not just a website';
    contentKeywords = 'Technology Software, Web Development, API integration, PHP Development, Next.js development, React.js development, Node.js development, CMS Development, MVC Development, Android Application, iPhone Application, UI/UX Designing, UI Designing, 3D Designing, Logo Designing, Cloud computing, Artificial intelligence, Data analytics, Cybersecurity, Web development, Mobile app development, IT consulting, Virtual reality, Augmented reality, Web design Website development, Front-end development, Back-end development, Full-stack development, Responsive design, User interface (UI), User experience (UX), Custom web development, E-commerce development, Laravel development, Yii development, Codeigniter development, Content management systems (CMS), WordPress development, Drupal development, Magento development, Shopify development, Mobile-friendly websites, Cross-browser compatibility, Web application development, API integration, Website maintenance';
    siteTitle = 'Revolutionary IT Solutions – XipeTech';

    constructor(private metaService: MetaService, private router: Router) { }

    ngOnInit(): void {
        const baseUrl = window.location.origin;

        // Set the page meta data
        this.metaService.setMetaData({
            title: this.contentTitle,
            description: this.contentDescription,
            keywords: this.contentKeywords,
            siteTitle: this.siteTitle,
            pageUrl: `${baseUrl}${this.router.url}`,
            imageUrl: `${baseUrl}/assets/img/xipetech.png`,
            ext: 'png'
        });
    }

    ngAfterViewInit(): void {
        this.domUpdateTimeout = setTimeout(() => {
            this.applyDomManipulations();
        }, 0);
    }

    private applyDomManipulations(): void {
        // Set background colors
        if ($("[data-bg-color]").length > 0) {
            $("[data-bg-color]").filter(function () {
                return this.nodeType === 1;
            }).each(function () {
                const color = $(this).attr("data-bg-color");
                $(this).css("background-color", color);
                $(this).removeAttr("data-bg-color");
            });
        }

        // Set custom border color via CSS variable
        if ($("[data-border]").length > 0) {
            $("[data-border]").each(function () {
                const borderColor = $(this).data("border");
                $(this).css("--th-border-color", borderColor);
            });
        }

        // Set mask image
        if ($("[data-mask-src]").length > 0) {
            $("[data-mask-src]").each(function () {
                const mask = $(this).attr("data-mask-src");
                $(this).css({
                    "mask-image": "url(" + mask + ")",
                    "-webkit-mask-image": "url(" + mask + ")"
                });
                $(this).addClass("bg-mask");
                $(this).removeAttr("data-mask-src");
            });
        }
    }

    ngOnDestroy(): void {
        if (this.domUpdateTimeout) {
            clearTimeout(this.domUpdateTimeout);
        }
    }

    onImageError(event: Event) {
        const imgElement = event.target as HTMLImageElement;
        imgElement.src = 'assets/img/noimage.png';
    }
}